import { useEffect, useRef } from "react";
import UploadIcon from "../icons/UploadIcon";
import QuestionMarkIcon from "../icons/QuestionMarkIcon";
import "@google/model-viewer";

const ModelUploader = ({ onModelUpload, type, modelFile }) => {
  const uploadRef = useRef(null);
  const is3d = type === "3d";
  const acceptedFileTypes = is3d ? ".glb" : ".png, .jpg, .jpeg";
  const modelPreviewURL = modelFile ? URL.createObjectURL(modelFile) : null;

  useEffect(() => {
    // Handle cancel item being clicked
    if (modelFile == null) {
      uploadRef.current.value = "";
    }
  }, [modelFile]);

  const handleModelFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const newUrl = URL.createObjectURL(file);
      if (newUrl !== modelPreviewURL) {
        onModelUpload(file);
      }
    }
  };

  const handleReplaceModel = () => {
    uploadRef.current.click();
  };

  const is3DFile = (file) =>
    file.type === "model/gltf-binary" ||
    file.name.endsWith(".glb") ||
    file.name.endsWith(".usdz");

  return (
    <div className="menu-item-upload-photo">
      {!modelPreviewURL && (
        <div
          onClick={() => uploadRef.current.click()}
          className="menu-item-upload-photo"
        >
          <UploadIcon size="40px" />
          <h2 className="menu-item-upload-text">
            {is3d ? (
              <>
                upload 3D model <br /> (.glb)
              </>
            ) : (
              <>
                upload 2D image <br /> (.jpg / .png)
              </>
            )}
          </h2>
          <div className="menu-item-upload-question-icon">
            <QuestionMarkIcon />
          </div>
        </div>
      )}
      {modelPreviewURL && is3DFile(modelFile) && (
        <div className="menu-item-model-preview">
          <model-viewer
            src={modelPreviewURL}
            alt="3D model preview"
            auto-rotate
            camera-controls
            shadow-intensity="1"
            style={{ width: "250px", height: "250px" }}
          ></model-viewer>
          <button
            className="menu-item-replace-button"
            onClick={handleReplaceModel}
          >
            replace
          </button>
        </div>
      )}
      {modelPreviewURL && !is3DFile(modelFile) && (
        <div>
          <img
            src={modelPreviewURL}
            className="img-preview"
            alt="model preview"
            onClick={() => uploadRef.current.click()}
          />
          <button
            className="menu-item-replace-button flat-replace-button"
            onClick={handleReplaceModel}
          >
            replace
          </button>
        </div>
      )}
      <input
        ref={uploadRef}
        type="file"
        accept={acceptedFileTypes}
        onChange={handleModelFileChange}
        style={{ display: "none" }}
      />
    </div>
  );
};

export default ModelUploader;
